// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"styles_confirmModal__2a0Vb","overlayConfirmModal":"styles_overlayConfirmModal__yW0-S","buttonContainer":"styles_buttonContainer__2r_LB"};